import React from 'react'
import classNames from 'classnames'

export type LoadingLineProps = {
  size?: number
  lineWidth?: number | string
  marginBottom?: number
  marginTop?: number
  iconClass?: string
  iconSize?: number
}

export const LoadingLine = React.memo(
  ({
    size = 16,
    lineWidth = '100%',
    marginBottom = 15,
    marginTop = 0,
    iconClass,
    iconSize,
  }: LoadingLineProps) => {
    return (
      <div
        className="flexbox flexbox-align-center width-full"
        style={{
          height: iconSize || size,
          marginBottom,
          marginTop,
        }}
      >
        {iconClass &&
          React.createElement(iconClass, {
            size: iconSize || size,
            style: { marginRight: 8, verticalAlign: '-1px' },
            className: 'shade-30',
          })}
        <div
          className={classNames(
            'flexbox-no-grow width-full radius-normal',
            'background-shade-50'
          )}
          style={{
            width: lineWidth,
            height: size,
          }}
        />
      </div>
    )
  }
)
